import {
    INIT_MEDICAL_AGENDA,
    MEDICAL_AGENDA,
    ERROR_MEDICAL_AGENDA,
    INIT_SAVE_RESULT_TEST,
    SAVE_RESULT_TEST,
    ERROR_SAVE_RESULT_TEST,
} from 'happ-redux/happ-types';
import {getMedicalAgendaById, updateTestAgendaById} from 'happ-services/agenda_medica/agenda_medica';

export function getMedicalAgenda(patient){
    return async (dispatch) => {
        dispatch(init_medical_agenda);
        try {
            const token = localStorage.getItem('token');
            const response = await getMedicalAgendaById(token);
            if (response.status === 200){
                dispatch(medical_agenda(response.data));
            } else {
                dispatch(error_medical_agenda(response.data.msg))
            }
        } catch (error) {
            dispatch(error_medical_agenda(error.data.msg))
        }
    }
}


export function saveResultTest(medical_agenda, test_id, code, stage){
    return async (dispatch) => {
        dispatch(init_save_result_test)
        try {
            const token = localStorage.getItem('token');
            const body = {};
            body._id = medical_agenda;
            body.derivateBenefitId = test_id;
            body.code = code;
            body.stage = stage;
            body.patient = token;
            const response = await updateTestAgendaById(body);
            if (response.status === 200) {
                dispatch(save_result_test(response.data));
            } else {
                dispatch(error_save_result_test(response.data.msg));
            }
        } catch (error) {
            dispatch(error_save_result_test(error.data.msg));   
        }
    }
}

const init_medical_agenda = () => ({
    type: INIT_MEDICAL_AGENDA
});

const medical_agenda = response => ({
    type: MEDICAL_AGENDA,
    payload: response
});

const error_medical_agenda = error => ({
    type: ERROR_MEDICAL_AGENDA,
    payload: error
})

const init_save_result_test = () => ({
    type: INIT_SAVE_RESULT_TEST,
})

const save_result_test = response => ({
    type: SAVE_RESULT_TEST,
    payload: response
});

const error_save_result_test = error => ({
    type: ERROR_SAVE_RESULT_TEST,
    payload: error
})